import {
  SetTopPercentageForCompanyCountryMutation,
  SetTopPercentageForCompanyCountryMutationVariables,
  SetIsTagAssignmentInProgressForCompanyCountryMutation,
  SetIsTagAssignmentInProgressForCompanyCountryMutationVariables,
} from './../../../types'
import {
  CONFIRM_TAG_ASSIGNMENT_FOR_COMPANY_COUNTRY,
  SET_IS_TAG_ASSIGNMENT_IN_PROGRESS_FOR_COMPANY_COUNRTY,
  SET_TOP_PERCENTAGE_FOR_COMPANY_COUNTRY,
} from './../Mutations'
import {
  SET_LOW_PERCENTAGE_FOR_COMPANY_COUNTRY,
  SET_LOW_PERCENTAGE_IS_BLOCKER_FOR_COMPANY_COUNTRY,
  SET_DISABLE_RANKING_FOR_COMPANY_COUNTRY,
} from '../Mutations'
import { client } from '../../..'
import {
  Country,
  SetLowPercentageForCompanyCountryMutationVariables,
  SetLowPercentageForCompanyCountryMutation,
  SetLowPercentageIsBlockerForCompanyCountryMutation,
  SetLowPercentageIsBlockerForCompanyCountryMutationVariables,
  SetDisableRankingForCompanyCountryMutation,
  SetDisableRankingForCompanyCountryMutationVariables,
} from '../../../types'
import { COMPANY_RANKING_SETTINGS_FOR_COUNTRY } from '../Queries'
import { GraphQLFormattedError } from 'graphql'
import { FetchResult, MaybeMasked } from '@apollo/client'

export default (
  companyId: string,
  country: Country,
): {
  updateTopPercentage: (topPercentage: number) => Promise<SetTopPercentageForCompanyCountryMutation | null | undefined>
  updateLowPercentage: (lowPercentage: number) => Promise<SetLowPercentageForCompanyCountryMutation | null | undefined>
  updateLowPercentageIsBlocker: (
    lowPercentageIsBlocker: boolean,
  ) => Promise<SetLowPercentageIsBlockerForCompanyCountryMutation | null | undefined>
  updateRankingDisabled: (isDisabled: boolean) => Promise<SetDisableRankingForCompanyCountryMutation | null | undefined>
  enableRankingChanges: () => Promise<{
    data: SetIsTagAssignmentInProgressForCompanyCountryMutation | null | undefined
    errors: readonly GraphQLFormattedError<Record<string, unknown>>[] | undefined
  }>
  confirmRankingChanges: () => Promise<FetchResult<MaybeMasked<unknown>>>
} => {
  const updateTopPercentage = async (topPercentage: number): Promise<SetTopPercentageForCompanyCountryMutation | null | undefined> => {
    const variables = {
      companyId: companyId,
      country: country,
      topPercentage: topPercentage,
    }
    const { data } = await client.mutate<SetTopPercentageForCompanyCountryMutation, SetTopPercentageForCompanyCountryMutationVariables>({
      mutation: SET_TOP_PERCENTAGE_FOR_COMPANY_COUNTRY,
      variables: variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })

    return data
  }

  const updateLowPercentage = async (lowPercentage: number): Promise<SetLowPercentageForCompanyCountryMutation | null | undefined> => {
    const variables = {
      companyId: companyId,
      country: country,
      lowPercentage: lowPercentage,
    }
    const { data } = await client.mutate<SetLowPercentageForCompanyCountryMutation, SetLowPercentageForCompanyCountryMutationVariables>({
      mutation: SET_LOW_PERCENTAGE_FOR_COMPANY_COUNTRY,
      variables: variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })

    return data
  }

  const updateLowPercentageIsBlocker = async (
    lowPercentageIsBlocker: boolean,
  ): Promise<SetLowPercentageIsBlockerForCompanyCountryMutation | null | undefined> => {
    const variables = {
      companyId: companyId,
      country: country,
      lowPercentageIsBlocker: lowPercentageIsBlocker,
    }
    const { data } = await client.mutate<
      SetLowPercentageIsBlockerForCompanyCountryMutation,
      SetLowPercentageIsBlockerForCompanyCountryMutationVariables
    >({
      mutation: SET_LOW_PERCENTAGE_IS_BLOCKER_FOR_COMPANY_COUNTRY,
      variables: variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })

    return data
  }

  const updateRankingDisabled = async (isDisabled: boolean): Promise<SetDisableRankingForCompanyCountryMutation | null | undefined> => {
    const variables = {
      companyId: companyId,
      country: country,
      isDisabled: isDisabled,
    }
    const { data } = await client.mutate<SetDisableRankingForCompanyCountryMutation, SetDisableRankingForCompanyCountryMutationVariables>({
      mutation: SET_DISABLE_RANKING_FOR_COMPANY_COUNTRY,
      variables: variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })

    return data
  }

  // HR SHOULD ONLY BE ENABLE THIS BUT IN CASE OF FUTURE CHANGES WE SEND A TRUE VALUE BACKEND
  const enableRankingChanges = async (): Promise<{
    data: SetIsTagAssignmentInProgressForCompanyCountryMutation | null | undefined
    errors: readonly GraphQLFormattedError<Record<string, unknown>>[] | undefined
  }> => {
    const variables = {
      companyId: companyId,
      country: country,
      isEnabled: true,
    }
    const { data, errors } = await client.mutate<
      SetIsTagAssignmentInProgressForCompanyCountryMutation,
      SetIsTagAssignmentInProgressForCompanyCountryMutationVariables
    >({
      mutation: SET_IS_TAG_ASSIGNMENT_IN_PROGRESS_FOR_COMPANY_COUNRTY,
      variables: variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })

    return { data, errors }
  }

  const confirmRankingChanges = async (): Promise<FetchResult<MaybeMasked<unknown>>> => {
    const variables = {
      companyId,
      country,
    }

    return client.mutate({
      mutation: CONFIRM_TAG_ASSIGNMENT_FOR_COMPANY_COUNTRY,
      variables,
      refetchQueries: [
        {
          query: COMPANY_RANKING_SETTINGS_FOR_COUNTRY,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })
  }

  return {
    updateTopPercentage,
    updateLowPercentage,
    updateLowPercentageIsBlocker,
    updateRankingDisabled,
    enableRankingChanges,
    confirmRankingChanges,
  }
}
